import React, { useState } from 'react'; 
import styled from 'styled-components'; 
import LoginIcon from '../../../Assets/assetsnew/signup.svg';
import AssignmentIndIcon  from '../../../Assets/assetsnew/client project.svg'; 
import AccessTimeFilledIcon from '../../../Assets/assetsnew/clock.svg'; 
import ReceiptLongIcon from '../../../Assets/assetsnew/invoice 8.svg'; 
import LoginIconWhite from '../../../Assets/assetsnew/sign up white.svg';
import AssignmentIndIconWhite  from '../../../Assets/assetsnew/client project white.svg'; 
import AccessTimeFilledIconWhite  from '../../../Assets/assetsnew/Time track white.svg'; 
import ReceiptLongIconWhite from '../../../Assets/assetsnew/invoice white.svg'; 
import CTAThree from '../../UIs/CTAThree';
import LovedByIndians from '../../HomePage/LovedByIndians';
import TechStack from '../../UIs/TechStack';
import FAQAccordian from '../../UIs/FAQAccordian';

const Wrapper = styled.div`
  background-color: var(--white);
  overflow: hidden;
`;

const HeaderContainer = styled.div`
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 3rem 1rem;

   @media (max-width: 600px) {
    padding: 1.5rem 1rem 0;
  }
`;

const MainHeading = styled.h2`
  font-size: 36px;
  font-weight: 600;
  color:var(--font1);
  margin-bottom: 16px;

  @media (max-width: 992px) {
    font-size: 2rem;
  }

  @media (max-width: 576px) {
    font-size: 1.5rem;
  }
`;

const SubText = styled.p`
  color:var(--font1);
  line-height: 1.6;
`;

const StepsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  position: relative;
  margin: 0 auto 5rem auto;
  
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 50px;
    margin-bottom: 3.5rem;
  }
`;

const SvgContainer = styled.div`
  position: absolute;
  top: -10px;   
  left: 10%;   
  width: 80%;  
  height: 100px; 
  z-index: 0;
  pointer-events: none;

  @media (max-width: 900px) {
    display: none;
  }
`;

const IconBox = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  marginBottom: 24px;
  transition: all 0.3s ease;
  background-color: var(--backgroundPink);
  color: var(--bgButtonHoverColor);
  border: 1px solid var(--backgroundGrey);
  margin-bottom: 24px;
`;

const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  z-index: 1; 
  flex: 1;
  padding: 0 15px;
  cursor: pointer;

  &:hover ${IconBox} {
    background-color: var(--bgButtonHoverColor) !important; 
    transform: scale(1);
  }
`;

const StepTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color:var(--font1);
  margin-bottom: 12px;
`;

const StepDesc = styled.p`
  font-size: 16px;
  max-width: 240px;
  margin: 0;
`;

const HowItWorks = () => {
  const [hoveredId, setHoveredId] = useState(null);

  const steps = [
    {
      id: 1,
      title: "Sign Up for Free",
      description: "Create your account in seconds. No credit card required.",
      icon: <img src={LoginIcon} alt="Login" width="32" height="32" />,
      hoverIcon: <img src={LoginIconWhite} alt="Login" width="32" height="32" />,
    },
    {
      id: 2,
      title: "Add Clients & Projects",
      description: " Ditch spreadsheets. Organize clients and projects in one view.",
      icon: <img src={AssignmentIndIcon} alt="Assignment" width="32" height="32" />,
      hoverIcon: <img src={AssignmentIndIconWhite} alt="assignment" width="32" height="32" />,
    },
    {
      id: 3,
      title: "Track Time",
      description: "Capture every billable minute. Never work for free again.",
      icon: <img src={AccessTimeFilledIcon} alt="track time" width="36" height="36" />, 
      hoverIcon: <img src={AccessTimeFilledIconWhite} alt="track time" width="36" height="36" />, 
    },
    {
      id: 4,
      title: "Send Invoices",
      description: "Turn tracked hours into professional invoices instantly.",
      icon: <img src={ReceiptLongIcon} alt="invoice" width="32" height="32" />,
      hoverIcon: <img src={ReceiptLongIconWhite} alt="invoice"width="32" height="32" />,
    }
  ];

  const faqs = [
    { question: "Is Zodot free to use?", 
      answer: "Yes, you can get started with Zodot for free. You can upgrade anytime as your needs grow." },
    { question: "Do I need a credit card to sign up?", 
      answer: "No. You can create your account without adding a credit card." },
    { question: "Is Zodot suitable for freelancers and small teams?", 
      answer: "Absolutely. Zodot is built specifically for freelancers and small businesses to manage work easily." },
    { question: "How long does it take to get started?", 
      answer: "You can sign up and start using Zodot in just a few minutes." },
    { question: "Is my data secure?", 
      answer: "Yes. Your data is protected using industry-standard security practices." },
  ];

  return (
    <Wrapper>
      <HeaderContainer data-aos="fade-up">
        <MainHeading>How It Works</MainHeading>
        <SubText>
          No complex setup required. See how easy it is to go from "Sign Up" to "Get Paid" in four simple steps.
        </SubText>
      </HeaderContainer>

      <StepsContainer data-aos="fade-up">
        <SvgContainer>
           <svg width="100%" height="100%" preserveAspectRatio="none" viewBox="0 0 300 100">
             <path d="M 0,50 Q 50,10 100,50 T 200,50 T 300,50" fill="none" stroke="var(--backgroundPink)" strokeWidth="2" strokeDasharray="0 3" strokeLinecap="round" />
           </svg>
        </SvgContainer>

        {steps.map((step) => (
          <StepItem 
            key={step.id} 
            onMouseEnter={() => setHoveredId(step.id)}
            onMouseLeave={() => setHoveredId(null)}
          >
            <IconBox>
              {hoveredId === step.id ? step.hoverIcon : step.icon}
            </IconBox>

            <StepTitle>{step.title}</StepTitle>
            <StepDesc>{step.description}</StepDesc>
          </StepItem>
        ))}
      </StepsContainer>

      <CTAThree 
        customHeading="Join Freelancers & VAs Simplifying Their Work with Zodot"
        customDescription="From solo VAs to growing teams, see why professionals trust Zodot to manage projects, clients, and finances in one place."
      />
      <LovedByIndians/>
      <TechStack/>
      <FAQAccordian faqs={faqs}/>
    </Wrapper>
  );
};

export default HowItWorks;